import { render } from "./BecomeAFriendForm.vue?vue&type=template&id=7e41a9b7&scoped=true"
import script from "./BecomeAFriendForm.vue?vue&type=script&lang=js"
export * from "./BecomeAFriendForm.vue?vue&type=script&lang=js"

import "./BecomeAFriendForm.vue?vue&type=style&index=0&id=7e41a9b7&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lawrenj\\source\\repos\\Bitbucket_Cloud\\tgi_friends_of_gideons_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e41a9b7"]])

export default __exports__